import { Grid as BaseGrid, styled } from '@mui/material'
import { DeleteOutline, InsertDriveFile } from '@mui/icons-material'

export const DialogContent = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`
export const DialogIcon = styled('img')`
  width: 64px;
`
export const DialogMessage = styled('div')`
  margin: 20px 0 0;
  text-align: center;
  width: 100%;
`
export const DialogFooter = styled('div')`
  display: flex;
  justify-content: space-around;
  gap: 10px;
`

export const DialogAttachment = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
  }
`

export const HiddenFileInput = styled('input')`
  display: none;
`

export const SelectFileButton = styled('button')`
  background-color: ${props => props.theme.palette.blue[95]};
  border: 1px solid ${props => props.theme.palette.blue[50]};
  border-radius: 24px;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  padding: 10px 28px;
  white-space: nowrap;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const LoadedFileDivider = styled('hr')`
  border: none;
  border-top: 1px solid ${props => props.theme.palette.gray[90]};
  margin: ${props => props.margin || '12px 0'};
  width: 100%;
`

export const LoadedFileRow = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const LoadedFileInfo = styled('div')`
  align-items: center;
  display: flex;
  gap: 6px;
  min-width: 0;
`

export const LoadedFileIcon = styled(InsertDriveFile)`
  color: ${props => props.theme.palette.blue[50]};
  font-size: 20px;
`

export const LoadedFileName = styled('span')`
  color: ${props => props.theme.palette.blue[50]};
  overflow: hidden;
  text-decoration: underline;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const LoadedFileSize = styled('span')`
  color: ${props => props.theme.palette.gray[50]};
  flex-shrink: 0;
`

export const DeleteFileButton = styled('button')`
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  display: flex;
  gap: 4px;
  padding: 0;
`

export const DeleteFileIcon = styled(DeleteOutline)`
  font-size: 20px;
`

export const DeleteFileText = styled('span')`
  text-decoration: underline;
`
